export const getOptionLabel = (value, options) => {
  const o = options.find(o => (o.key || o.value) === value)
  return o ? o.readOnlyLabel || o.label : '-'
}
